export function isBeta(): boolean {
    return window.location.host === 'beta.www.autoixpert.de';
}
